import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import {
    PageBehaviourButton,
    IconArrow,
} from '@ratehub/base-ui';


function BackButton({ onClick, children, ...otherProps }) {
    const intl = useIntl();

    return (
        <PageBehaviourButton
            onClick={onClick}
            iconComponent={IconArrow}
            iconLocation="left"
            size="small"
            target="blank"
            {...otherProps}
        >
            { children ? children : intl.formatMessage(Messages.BACK) }
        </PageBehaviourButton>
    );
}

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

const Messages = defineMessages({
    BACK: {
        id: 'InsuranceShared.backButton.defaultText',
        defaultMessage: 'Back',
    },
});

export default BackButton;